export default "__VITE_PUBLIC_ASSET__7a0ba393__"